/**
 * Pull organization ids out of whatever the operator pasted.
 *
 * The list arrives as a block of text copied from a ticket, and its shape is not
 * worth constraining: one id per line, a comma-separated row, or the
 * `Practice Name (Dr Someone) - <uuid>` form the rollout tickets are written in.
 * Scanning for anything UUID-shaped reads all of them without asking the operator
 * to reformat, and ignores the surrounding names and punctuation.
 *
 * Ids are lowercased and de-duplicated, so the same organization listed twice is
 * one entry. Order is the order they appear, which keeps the result readable
 * against the list that was pasted.
 */
const UUID_PATTERN = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi

export const parseOrgIds = (text: string): string[] => {
  const matches = text.match(UUID_PATTERN) ?? []
  return [...new Set(matches.map((id) => id.toLowerCase()))]
}
